import http from '@/app/http-common-admin';
import httpStudents from '@/app/http-common-students';
import httpProfrssors from '@/app/http-common-professors';
import httpCandidatures from '@/app/http-common-candidatures';


export const getUserEmail = async (email, pswd, typeUtilizateur) => {

  try {
    const response = await http.get(`/usersLogin?email=${email}&pswd=${pswd}&typeUtilizateur=${typeUtilizateur}`);

    return response;
  } catch (error) {
    return error.response; // This will contain the response details, including status code
  }
};


export const getUserEmailProfessors = async (email, pswd, typeUtilizateur) => {
  try {
    const response = await httpProfrssors.get(`/usersLogin/professeur?email=${email}&pswd=${pswd}&typeUtilizateur=${typeUtilizateur}`);
    return response;
  } catch (error) {
    // Handle errors explicitly
    return error.response; // This will contain the response details, including status code
  }
};

export const getUserEmailUpdateData = async (email) => {
  try {
    const response = await http.get(`/usersLogin/updateData?email=${email}`);
    return response;
  } catch (error) {
    return error.response; // This will contain the response details, including status code
  }
};

export const getUserEmailEtudiants = async (email, pswd) => {
  try {
    const response = await httpStudents.get(`/usersLogin/usersLoginEtudiants?email=${email}&pswd=${pswd}`);
    return response;
  } catch (error) {
    // Handle errors explicitly
    return error.response; // This will contain the response details, including status code
  }
};

export const getUserEmailInscriptions = async (email, pswd) => {
  return await httpCandidatures.get(`/usersLoginInscriptions?email=${email}&pswd=${pswd}`);
};



export const getUserAdminConnectd = async (email) => {
  try {
    const response = await http.get(`/usersLogin/checkUserIsconnected?email=${email}`);

    // Check if response.data is an array and not empty
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0]; // Return the first element of the array
    } else {
      return null; // Handle case where no users are connected
    }
  } catch (error) {
    return null; // Return null in case of error
  }
};


export const getUserProfesseurConnectd = async (email) => {
  try {
    const response = await httpProfrssors.get(`/usersLogin/checkUserIsconnected?email=${email}`);

    // Check if response.data is an array and not empty
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0]; // Return the first element of the array
    } else {
      return null; // Handle case where no users are connected
    }
  } catch (error) {
    return null; // Return null in case of error
  }
};

export const getUserEtudiantConnectd = async (email) => {
  try {
    const response = await httpStudents.get(`/UserEtudiantLogin/checkUserIsconnected?email=${email}`);

    // Check if response.data is an array and not empty
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0]; // Return the first element of the array
    } else {
      return null; // Handle case where no users are connected
    }
  } catch (error) {
    return null; // Return null in case of error
  }
};


export const userAdminDisconect = async (email, pswd) => {
 
  const response = await http.get(`/usersLogin/disconnectFromOtherComouter?email=${email}&pswd=${pswd}`);
    return response;
 
};

export const getUserStudentEmailUpdateData = async (email) => {
  try {
    const response = await httpStudents.get(`/UserEtudiantLogin/updateData?email=${email}`);
    return response;
  } catch (error) {
    console.log(error)
    return error.response; // This will contain the response details, including status code
  }
};

export const getIfCanDisconnect = async (email) => {
  try {
    const response = await http.get(`/usersLogin/getIfCanDisconnect?email=${email}`);

    // Check if response.data is an array and not empty
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0]; // Return the first element of the array
    } else {
      return null; // Handle case where no users are connected
    }
  } catch (error) {
    return null; // Return null in case of error
  }
};

export const getIfCanDisconnectStudent = async (email) => {
  try {
    const response = await httpStudents.get(`/UserEtudiantLogin/getIfCanDisconnect?email=${email}`);

    // Check if response.data is an array and not empty
    if (Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0]; // Return the first element of the array
    } else {
      return null; // Handle case where no users are connected
    }
  } catch (error) {
    return null; // Return null in case of error
  }
};



export const getIpAddressLocalization = async (ip) => {
  try {
    const response = await http.get(`/usersLogin/getIpAddressLocalization?ip=${ip}`);
    return response.data;
   
  } catch (error) {
    return null; // Return null in case of error
  }
};



